var exports = {
  "J": "ProductAnnouncementBannerAnimation__jgze8O",
};

module.exports = exports;
